import React from 'react'
import P1  from '../images/portfolio/p-1.png'
import P2  from '../images/portfolio/p-2.png'
import P3  from '../images/portfolio/p-3.png'
import P4  from '../images/portfolio/p-4.png'
import P5  from '../images/portfolio/p-5.png'
import P6  from '../images/portfolio/p-6.png'
const Portfolio = () => {
  const PortfollioData = [
    {
        id:1,
        img:P1,
        title: 'Type Your portfolio details',
        submitted_date: '12 August 2025',
        cols:'3',
        des: 'lorem'
    },
    {
        id:2,
        img:P2,
        title: 'Type Your portfolio details',
        submitted_date: '12 August 2025',
        cols:'4',
        des: 'lorem'
    },
    {
        id:3,
        img:P3,
        title: 'Type Your portfolio details',
        submitted_date: '12 August 2025',
        cols:'3',
        des: 'lorem'
    },
    {
        id:4,
        img:P4,
        title: 'Type Your portfolio details',
        submitted_date: '12 August 2025',
        cols:'4',
        des: 'lorem'
    },
    {
        id:5,
        img:P5,
        title: 'Type Your portfolio details',
        submitted_date: '12 August 2025',
        cols:'3',
        des: 'lorem'
    },
    {
        id:6,
        img:P6,
        title: 'Type Your portfolio details',
        submitted_date: '12 August 2025',
        cols:'4',
        des: 'lorem'
    }
  ]
  return (
    <section id='portfolio' className="py-16">
    <div className="mx-auto max-w-7xl px-8 md:px-6">
        <div className="mb-10 text-center">
            <span className="font-medium text-blue-500">Our Portfolio</span>
            <h1 className="text-2xl font-bold text-slate-700 sm:text-3xl">Our Recent Works</h1>
            <p className="mx-auto max-w-2 mt-2 text-slate-500">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur deleniti sit dolor numquam non. Et.</p>
        </div>
        <div className="flex flex-col gap-5">
            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-4">

            {PortfollioData && PortfollioData.map((data)=>(
                <div className={`group relative h-40 overflow-hidden rounded-lg lg:h-52 ${data.id % 3 === 0  && ' sm:col-span-2'}`}>
                    <img src={data.img} alt="portfolio img" className="absolute h-full w-full object-cover duration-200 group-hover:scale-125" />
                    <div className="absolute -bottom-60 flex w-full cursor-pointer items-center justify-between bg-gradient-to-t from-slate-800 px-3 pb-4 pt-10 duration-200 group-hover:-bottom-0">
                        <p className="text-sm font-semibold text-white">{data.title} <span className="text-xs text-slate-300 block">{data.submitted_date}</span></p>
                        <ion-icon name="heart" className="rounded-full bg-white p-1.5 text-lg text-blue-500"></ion-icon>
                    </div>
                </div>
            ))}
                
            </div>



          
        </div>
    </div>
</section>

  )
}

export default Portfolio